import { render, staticRenderFns } from "./gaia48.vue?vue&type=template&id=ac1ab056&scoped=true&"
import script from "./gaia48.vue?vue&type=script&lang=js&"
export * from "./gaia48.vue?vue&type=script&lang=js&"
import style0 from "./gaia48.vue?vue&type=style&index=0&lang=less&"
import style1 from "./gaia48.vue?vue&type=style&index=1&id=ac1ab056&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1ab056",
  null
  
)

export default component.exports